import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogWorkdaysComponent } from 'app/components/dialog-workdays/dialog-workdays.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogWorkdaysService {

  constructor(private dialog: MatDialog) { }

  openDialog(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogWorkdaysComponent, {
      data: data,
    });

    return dialogRef.afterClosed();
  }
}
